export default __webpack_public_path__ + "static/media/train32.0a009d84.png";